<template>
  <div
    v-if="policy.canAcceptHuman || policy.canRejectHandoff"
    class="agent-service-handoff-bar"
    :class="{ 'is-mobile': mobile }"
    role="status"
  >
    <div class="status-copy">
      <!-- 客户请求真人服务 -->
      <strong>{{ $t("agentServiceUI.handoffRequested") }}</strong>
      <!-- 接受后由您直接回复；拒绝则恢复 Agent。 -->
      <span>{{ $t("agentServiceUI.handoffHint") }}</span>
    </div>
    <div class="control-actions">
      <!-- 拒绝接管 -->
      <button
        v-if="policy.canRejectHandoff"
        type="button"
        :disabled="controlChanging"
        @click="$emit('change-control', 'reject')"
      >
        {{ $t("agentServiceUI.rejectHandoff") }}
      </button>
      <!-- 接管会话 -->
      <button
        v-if="policy.canAcceptHuman"
        type="button"
        class="primary"
        :disabled="controlChanging"
        @click="$emit('change-control', 'accept')"
      >
        {{ $t("agentServiceUI.acceptHandoff") }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "AgentServiceHandoffBar",
  props: {
    mobile: { type: Boolean, default: false },
    policy: { type: Object, required: true },
    agentProcessing: { type: Boolean, default: false },
    controlChanging: { type: Boolean, default: false },
    realtimeState: { type: String, default: "CLOSED" },
  },
};
</script>

<style lang="less" scoped>
.agent-service-handoff-bar {
  &.is-mobile {
    position: static;
    flex: 0 0 auto;
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
    max-width: none;
    margin: 0 12px 8px;
    box-shadow: none;
    .control-actions { flex-wrap: nowrap; overflow-x: auto; button { flex: 1 0 auto; min-height: 44px; white-space: nowrap; } }
  }
  position: absolute;
  top: 72px;
  right: 16px;
  z-index: 8;
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: min(420px, calc(100% - 32px));
  min-height: 56px;
  padding: 10px 12px;
  border: 1px solid #c7dcfd;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);

  .status-copy {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
    color: #56615b;
    font-size: 13px;

    strong {
      color: #334155;
      font-size: 13px;
    }
    span {
      color: #667085;
      font-size: 12px;
    }
  }

  .control-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;

    button {
      min-height: 36px;
      padding: 6px 11px;
      border: 1px solid #ced8d3;
      border-radius: 4px;
      background: #fff;
      color: #555;
      cursor: pointer;

      &.primary {
        border-color: #07c160;
        background: #07c160;
        color: #fff;
      }

      &:disabled {
        cursor: not-allowed;
        border-color: #dde3ee;
        background: #f8fafc;
        color: #98a2b3;
      }
    }
  }
}

@media (max-width: 600px) {
  .agent-service-handoff-bar {
    top: 68px;
    right: 12px;
    gap: 8px;

    .control-actions button {
      min-height: 44px;
    }
  }
}
</style>
